import { CandidateNotesFeed } from '@/features/recruitment/components/candidate-notes-feed';
import { useAuthStore } from '@/stores/auth';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/recruitment/candidates_/$id/notes')({
  component: NotesTab,
});

function NotesTab() {
  const { id } = Route.useParams();
  const currentUserId = useAuthStore((s) => s.user?.employee?.id ?? null);

  return <CandidateNotesFeed candidateId={id} currentUserId={currentUserId} />;
}
